"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _useHoverCycle = _interopRequireWildcard(require("web/shared/icons/useHoverCycle"));
var _CopyTextButton = _interopRequireDefault(require("web/shared/components/CopyTextButton"));
var _ImageCandidateActions = _interopRequireDefault(require("web/shared/imageCandidates/ImageCandidateActions"));
var _ImageCandidateFullScreen = require("web/shared/imageCandidates/ImageCandidateFullScreen.styles");
var _imageCandidateWording = require("web/shared/imageCandidates/imageCandidateWording");
var _useEscapeToClose = _interopRequireDefault(require("web/shared/hooks/useEscapeToClose"));
var _stopPropagation = _interopRequireDefault(require("web/shared/utils/stopPropagation"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* One candidate as large as the window allows, with its actions and the
* file's name, size, and URL under it. It grows out of the card it was
* tapped from, given that card's box in window coordinates, and shrinks
* back on closing; without one it simply appears. Closed by the close
* mark, the ground, or Escape. The parent owns which candidate is shown;
* this holds on to it through the closing animation.
*/ // A rectangle in window coordinates: where a picture is, or was.
// The candidate to show and where it is being opened from.
// Runs the picture between its place on the strip and its place here, in
// either direction. Nothing happens where the platform cannot animate.
function runGrowth(picture, from, direction) {
  // Older engines, and the test DOM, have no Web Animations.
  if (!("animate" in picture) || prefersReducedMotion()) {
    return;
  }
  const rect = picture.getBoundingClientRect();
  const away = transformOnto(from, {
    top: rect.top,
    left: rect.left,
    width: rect.width,
    height: rect.height
  });
  const frames = direction === "in" ? [{
    transform: away
  }, {
    transform: "none"
  }] : [{
    transform: "none"
  }, {
    transform: away
  }];
  picture.animate(frames, {
    duration: direction === "in" ? _ImageCandidateFullScreen.GROW_MS : _ImageCandidateFullScreen.EXIT_MS,
    easing: "cubic-bezier(0.2, 0.8, 0.2, 1)",
    fill: "both"
  });
}
function prefersReducedMotion() {
  return typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
} // The transform that lays a picture at `to` over `from`, about its center.
function transformOnto(from, to) {
  const dx = from.left + from.width / 2 - (to.left + to.width / 2);
  const dy = from.top + from.height / 2 - (to.top + to.height / 2);
  return "translate(".concat(dx, "px, ").concat(dy, "px) scale(").concat(from.width / to.width, ", ").concat(from.height / to.height, ")");
}
function ImageCandidateFullScreen(props) {
  var _candidate$objectKey$;
  const request = props.request,
    onClose = props.onClose;
  const wording = (0, _imageCandidateWording.useImageCandidateWording)(); // The request still drawn while the view leaves: the parent may already
  // have let go of it, so it is held here for the length of the exit.
  const _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    leaving = _useState2[0],
    setLeaving = _useState2[1];
  const _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    closing = _useState4[0],
    setClosing = _useState4[1];
  const shown = closing ? leaving : request;
  const picture = (0, _react.useRef)(null);
  const _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    closePointed = _useState6[0],
    setClosePointed = _useState6[1];
  const closeProgress = (0, _useHoverCycle.default)(closePointed, _useHoverCycle.GLYPH_CYCLE_MS); // Where the current request opened from, read by the arrival below: the
  // growth belongs to an arrival, not to the row changing under it, so it
  // is keyed by the candidate and reads the place from here.
  const openedFrom = (0, _react.useRef)(null);
  openedFrom.current = request == null ? null : request.from;
  const requestClose = (0, _react.useCallback)(() => {
    if (request == null || closing) {
      return;
    }
    if (picture.current != null && request.from != null) {
      runGrowth(picture.current, request.from, "out");
    }
    setLeaving(request);
    setClosing(true);
  }, [request, closing]); // Grow in, once, as a candidate arrives.
  const arrivedId = request == null ? null : request.candidate.id;
  (0, _react.useLayoutEffect)(() => {
    const from = openedFrom.current;
    if (arrivedId == null || from == null || picture.current == null) {
      return;
    }
    runGrowth(picture.current, from, "in");
  }, [arrivedId]);
  (0, _react.useEffect)(() => {
    if (!closing) {
      return undefined;
    }
    const timer = setTimeout(() => {
      setClosing(false);
      setLeaving(null);
      onClose();
    }, _ImageCandidateFullScreen.EXIT_MS);
    return () => clearTimeout(timer);
  }, [closing, onClose]);
  (0, _useEscapeToClose.default)(request != null, requestClose);
  if (shown == null) {
    return null;
  }
  const candidate = shown.candidate;
  const chosen = candidate.selection === "CHOSEN" || props.choosing;
  const name = (_candidate$objectKey$ = candidate.objectKey.split("/").pop()) !== null && _candidate$objectKey$ !== void 0 ? _candidate$objectKey$ : candidate.objectKey;
  const format = candidate.contentType.replace("image/", "").toUpperCase();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateFullScreen.styles.overlay, closing && _ImageCandidateFullScreen.styles.overlayOut)), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "".concat(wording.viewName, " ").concat(name)
    }, stylex.props(_ImageCandidateFullScreen.styles.view)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateFullScreen.styles.stage)), {}, {
        onClick: requestClose,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateFullScreen.styles.frame)), {}, {
          onClick: _stopPropagation.default,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", (0, _objectSpread2.default)({
            ref: picture,
            src: candidate.url,
            width: candidate.width,
            height: candidate.height,
            alt: "".concat(chosen ? wording.chosenName : wording.candidateName, " ").concat(name)
          }, stylex.props(_ImageCandidateFullScreen.styles.picture))), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
            type: "button",
            "aria-label": "Close",
            title: "Close",
            disabled: closing,
            onClick: requestClose,
            onMouseEnter: () => setClosePointed(true),
            onMouseLeave: () => setClosePointed(false),
            onFocus: () => setClosePointed(true),
            onBlur: () => setClosePointed(false)
          }, stylex.props(_ImageCandidateFullScreen.styles.close)), {}, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
              name: "x-mark",
              size: "l",
              progress: closeProgress
            })
          }))]
        }))
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateFullScreen.styles.actions, closing && _ImageCandidateFullScreen.styles.actionsOut)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageCandidateActions.default, {
          candidate: candidate,
          only: props.only,
          choosing: props.choosing,
          busy: props.busy || closing,
          view: null,
          onChoose: props.onChoose,
          onDelete: props.onDelete
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateFullScreen.styles.details)), {}, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateFullScreen.styles.name)), {}, {
            children: name
          })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateFullScreen.styles.meta)), {}, {
            children: [format, " \xB7 ", candidate.width, " \xD7 ", candidate.height]
          })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateFullScreen.styles.source)), {}, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("a", (0, _objectSpread2.default)((0, _objectSpread2.default)({
              href: candidate.url,
              target: "_blank",
              rel: "noreferrer"
            }, stylex.props(_ImageCandidateFullScreen.styles.url)), {}, {
              children: candidate.url
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CopyTextButton.default, {
              text: candidate.url,
              label: "Copy URL",
              copy: null
            })]
          }))]
        }))]
      }))]
    }))
  }));
}
var _default = exports.default = ImageCandidateFullScreen;